import { onUnmounted, ref, watch } from 'vue';

const accept = ref<boolean>(false);
const showValidationError = ref<boolean>(false);
export function useTermsAndConditions() {
    const setMaybeShowValidationError = () => {
        showValidationError.value = !accept.value;
    };

    const trySubmitTerms = (): boolean => {
        setMaybeShowValidationError();
        return accept.value;
    };

    const clearAccept = () => {
        accept.value = false;
    };

    watch(accept, setMaybeShowValidationError);
    onUnmounted(clearAccept);

    return {
        accept,
        showValidationError,
        trySubmitTerms,
    };
}
